import { flexRender } from "@tanstack/react-table";
import { clsx } from "@/utils";
import { DataTableCell as Cell } from "../types";

export interface DataTableCellProps<T extends object> extends React.ComponentProps<"div"> {
  cell: Cell<T, unknown>;
}

export const DataTableCell = <T extends object>({ cell, className, ...props }: DataTableCellProps<T>) => {
  const columnId = cell.column.id;
  const isFirstColumn = columnId === "offloadIcon";
  const firstColumnStyles = isFirstColumn ? "sm:bg-neutral-surface-gray sm:border-r-[2px] sm:border-neutral-mid-gray" : "";

  return (
    <div
      key={cell.id}
      /* `overflow-ellipsis` here was always inert: text-overflow does nothing on a flex container.
         The cells ellipse themselves; what they need from the cell is permission to shrink —
         a flex item defaults to min-width:auto and so refuses to go below its content width,
         which is why truncate/line-clamp silently no-opped once columns became resizable. */
      className={clsx("td flex min-w-0 items-center overflow-hidden [&>*]:min-w-0", firstColumnStyles, className)}
      style={{ width: cell.column.getSize() }}
      {...props}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </div>
  );
};
